export default __webpack_public_path__ + "static/media/avatar.1904afc5.jpg";